import { render, staticRenderFns } from "./ShipmentDashboardBoxPackingPage.vue?vue&type=template&id=614b2ce1&scoped=true&"
import script from "./ShipmentDashboardBoxPackingPage.vue?vue&type=script&lang=js&"
export * from "./ShipmentDashboardBoxPackingPage.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentDashboardBoxPackingPage.vue?vue&type=style&index=0&id=614b2ce1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614b2ce1",
  null
  
)

export default component.exports